import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolves a backend-relative image URL (e.g. /api/images/abc) to a full URL.
// Absolute URLs pass through unchanged.
export function imageUrl(url) {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}

// withCredentials sends the httpOnly auth cookie on every request.
export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
